<template>
  <div class="main">
    <div class="phone">
      <img style="width: 18vw;" class="left" src="../assets/images/mobile/home/1.png">
      总部电话：<em style="font-size: 20px;">010-63967431</em>
    </div>
    <div class="content">
      <div class="content_chara">
        <img class="left" src="../assets/images/mobile/home/6.png">
        <h3>使命</h3>
        <span>北京洁丽雅，让您的生活更健康！</span>
      </div>
      <div class="content_chara">
        <img class="left" src="../assets/images/mobile/home/7.png">
        <h3>核心价值观</h3>
        <span>乐观自信、勇于担当、信任协作、结果导向、客户满意!</span>
      </div>
      <div class="content_chara">
        <img class="left" src="../assets/images/mobile/home/8.png">
        <h3>愿景</h3>
        <span>服务全球，问鼎百年！</span>
      </div>
    </div>
    <div style="position: relative;background-color: rgba(247, 247, 247, 1);">
      <h4 style="color:#ffb400;font-size: 4vw;padding-top: 4vw;">为什么选择我们</h4>
      <div style="color:#696969;font-size: 3vw;padding-bottom:3vw">数万家企业和户主在享受我们的品质服务。</div>
      <div style="color:#fff;font-size: 3vw;position: absolute;top: 25vw;left: 40vw;width: 23vw;">丰富的行业管理经验</div>
      <div style="color:#fff;font-size: 3vw;position: absolute;top: 44vw;left: 15vw;width: 23vw;">全国规模的业务经营</div>
      <div style="color:#fff;font-size: 4vw;position: absolute;top: 49vw;left: 40vw;width: 23vw;">精干的员工管理团队</div>
      <div style="color:#fff;font-size: 3vw;position: absolute;top: 44vw;left: 64vw;width: 23vw;">社会的褒奖赞扬认可</div>
      <img style="width: 100vw;padding-bottom: 4vw;" src="../assets/images/mobile/home/9.png" alt="">
    </div>
    <!-- 新闻中心 -->
    <div>
      <h4 style="font-size: 6vw;color: #696969;padding-top: 6vw;"> <span style="color: #6cd01b;">新闻</span>中心</h4>
      <div style="color: #696969;font-size: 4vw;padding-bottom: 2vw;">遵纪守法，诚信经营，以质量赢得客户的满意</div>
    </div>
    <div class="news-list">
      <div class="news-item" @click="$router.push('/news/detail2')">
        <img class="news-img" src="../assets/images/mobile/home/10.png" alt="新闻1">
        <div class="news-content">
          <h5>【北京洁丽雅保洁有限公司】 企业宣传片</h5>
          <p class="news-time">发布时间：2023-07-25 17:08</p>
        </div>
      </div>
      <div class="news-item" @click="$router.push('/news/detail21')">
        <img class="news-img" src="../assets/images/mobile/home/11.png" alt="新闻2">
        <div class="news-content">
          <h5>创意Rap《下一站：“十四五”》主题MV</h5>
          <p class="news-time">发布时间：2023-07-25 17:07</p>
          <p class="news-desc">中国经济导报社、中国青年报社联合制作的主题歌曲:《下一站：十四五》，于2021年4月13日在国家发展和改革委员会官网发布，我司员工参与拍摄、出镜。视频来源：中国经济导报</p>
        </div>
      </div>
      <div class="news-item"
        @click="openExternalLink('https://news.cgtn.com/news/2020-01-18/Behind-Chunyun-Meet-post-00s-cleaner-on-high-speed-trains-NlxgU0GI0w/index.html')">
        <img class="news-img" src="../assets/images/mobile/home/12.png" alt="新闻2">
        <div class="news-content">
          <h5>CGTN （国内、海外版）《感动中国》 ：Behind Chunyun: Meet post-00s cleaner on high-speed trains</h5>
          <p class="news-time">发布时间：2023-07-25 17:09</p>
        </div>
      </div>
    </div>
    <!-- 列车保洁 -->
    <div @click="$router.push('/train-cleaning')">
      <img style="width: 100vw;" class="left" src="../assets/images/mobile/home/13.png">
      <van-swipe style="height: 50vw;" :autoplay="3000">
        <van-swipe-item style="display: flex;" v-for="item, index in trainList" :key="index">
          <div style="width: 50vw;">
            <img style="width: 45vw; height: 30vw; object-fit: cover;" :src="item.imagePath1">
            <h5 style="padding: 2vw; font-size: 4vw;">
              {{ item.title1 }}
            </h5>
          </div>
          <div style="width: 50vw; ">
            <img style="width: 45vw; height: 30vw; object-fit: cover;" :src="item.imagePath2">
            <h5 style="   padding: 2vw; font-size: 4vw;">
              {{ item.title2 }}
            </h5>
          </div>
        </van-swipe-item>
        <template #indicator>1</template>
      </van-swipe>
    </div>
    <!-- 家政保洁 -->
    <div @click="$router.push('/project-experience/housekeeping-service')">
      <img style="width: 100vw;" class="left" src="../assets/images/mobile/home/14.png">
      <van-swipe style="height: 50vw;" :autoplay="5000">
        <van-swipe-item style="display: flex;" v-for="item, index in houseList" :key="index">
          <div style="width: 50vw;">
            <img style="width: 45vw; height: 30vw; object-fit: cover;" :src="item.imagePath1">
            <h5 style="padding: 2vw; font-size: 4vw;">
              {{ item.title1 }}
            </h5>
          </div>
          <div style="width: 50vw; ">
            <img style="width: 45vw; height: 30vw; object-fit: cover;" :src="item.imagePath2">
            <h5 style="   padding: 2vw; font-size: 4vw;">
              {{ item.title2 }}
            </h5>
          </div>
        </van-swipe-item>
        <template #indicator>1</template>
      </van-swipe>
    </div>
  </div>
</template>

<script>
import cleanTrain1 from '@/assets/images/mobile/cleanTrain/1.jpg'
import cleanTrain2 from '../assets/images/mobile/cleanTrain/2.jpg'
import cleanTrain3 from '../assets/images/mobile/cleanTrain/3.jpg'
import cleanTrain4 from '../assets/images/mobile/cleanTrain/4.jpg'
import cleanTrain5 from '../assets/images/mobile/cleanTrain/5.jpg'
import cleanTrain6 from '../assets/images/mobile/cleanTrain/6.jpg'
import cleanTrain7 from '../assets/images/mobile/cleanTrain/7.jpg'
import cleanTrain8 from '../assets/images/mobile/cleanTrain/8.jpg'
import cleanTrain9 from '../assets/images/mobile/cleanTrain/9.jpg'
import cleanTrain10 from '../assets/images/mobile/cleanTrain/10.jpg'
import cleanTrain11 from '../assets/images/mobile/cleanTrain/11.jpg'
import cleanTrain12 from '../assets/images/mobile/cleanTrain/12.jpg'
import cleanTrain13 from '../assets/images/mobile/cleanTrain/13.jpg'
import cleanTrain14 from '../assets/images/mobile/cleanTrain/14.jpg'
import cleanTrain15 from '../assets/images/mobile/cleanTrain/15.jpg'
import cleanTrain16 from '../assets/images/mobile/cleanTrain/16.jpg'
import cleanTrain17 from '../assets/images/mobile/cleanTrain/17.jpg'
import cleanTrain18 from '../assets/images/mobile/cleanTrain/18.jpg'
import cleanTrain19 from '../assets/images/mobile/cleanTrain/19.jpg'
import cleanTrain20 from '../assets/images/mobile/cleanTrain/20.jpg'
import cleanTrain21 from '../assets/images/mobile/cleanTrain/21.jpg'
import cleanTrain22 from '../assets/images/mobile/cleanTrain/22.jpg'
import cleanTrain23 from '../assets/images/mobile/cleanTrain/23.jpg'
import cleanTrain24 from '../assets/images/mobile/cleanTrain/24.jpg'
import cleanTrain25 from '../assets/images/mobile/cleanTrain/25.jpg'
import cleanTrain26 from '../assets/images/mobile/cleanTrain/26.jpg'
import cleanTrain27 from '../assets/images/mobile/cleanTrain/27.jpg'
import cleanTrain28 from '../assets/images/mobile/cleanTrain/28.jpg'
import cleanTrain29 from '../assets/images/mobile/cleanTrain/29.jpg'
import cleanTrain30 from '../assets/images/mobile/cleanTrain/30.jpg'
import cleanTrain31 from '../assets/images/mobile/cleanTrain/31.jpg'
import cleanTrain32 from '../assets/images/mobile/cleanTrain/32.jpg'
import cleanTrain33 from '../assets/images/mobile/cleanTrain/33.jpg'
import cleanTrain34 from '../assets/images/mobile/cleanTrain/34.jpg'
import cleanTrain35 from '../assets/images/mobile/cleanTrain/35.jpg'
import cleanTrain36 from '../assets/images/mobile/cleanTrain/36.jpg'
import cleanTrain37 from '../assets/images/mobile/cleanTrain/37.jpg'
import cleanTrain38 from '../assets/images/mobile/cleanTrain/38.jpg'
import cleanTrain39 from '../assets/images/mobile/cleanTrain/39.jpg'
import cleanTrain40 from '../assets/images/mobile/cleanTrain/40.jpg'
import cleanTrain41 from '../assets/images/mobile/cleanTrain/41.jpg'
import cleanTrain42 from '../assets/images/mobile/cleanTrain/42.jpg'

import cleanHouse1 from '../assets/images/mobile/cleanHouse/1.jpg'
import cleanHouse2 from '../assets/images/mobile/cleanHouse/2.jpg'
import cleanHouse3 from '../assets/images/mobile/cleanHouse/3.jpg'
import cleanHouse4 from '../assets/images/mobile/cleanHouse/4.jpg'
import cleanHouse5 from '../assets/images/mobile/cleanHouse/5.jpg'
import cleanHouse6 from '../assets/images/mobile/cleanHouse/6.jpg'
import cleanHouse7 from '../assets/images/mobile/cleanHouse/7.jpg'
import cleanHouse8 from '../assets/images/mobile/cleanHouse/8.jpg'
import cleanHouse9 from '../assets/images/mobile/cleanHouse/9.jpg'
import cleanHouse10 from '../assets/images/mobile/cleanHouse/10.jpg'
import cleanHouse11 from '../assets/images/mobile/cleanHouse/11.jpg'
import cleanHouse12 from '../assets/images/mobile/cleanHouse/12.jpg'
import cleanHouse13 from '../assets/images/mobile/cleanHouse/13.jpg'
import cleanHouse14 from '../assets/images/mobile/cleanHouse/14.jpg'
export default {
  name: "Home",
  data() {
    return {
      navItems: [
        { title: '首页', route: '/' },
        { title: '列车保洁', route: '/train-cleaning' },
        { title: '项目经验', route: '/project-experience' },
        { title: '科研革新', route: '/scientific-research' },
        { title: '新闻中心', route: '/news' },
        { title: '企业文化', route: '/corporate-culture' },
        { title: '关于我们', route: '/about' },
        { title: '联系我们', route: '/career' }
      ],
      trainList: [
        {
          imagePath1: cleanTrain1,
          title1: "钥匙孔",
          imagePath2: cleanTrain2,
          title2: "车门把手",
        },
        {
          imagePath1: cleanTrain3,
          title1: "擦拭站台以下10公分",
          imagePath2: cleanTrain4,
          title2: "擦拭蓝线以下玻璃以上车身",
        },
        {
          imagePath1: cleanTrain5,
          title1: "车底匝盘",
          imagePath2: cleanTrain6,
          title2: "班前会",
        },
        {
          imagePath1: cleanTrain7,
          title1: "清除椅面垃圾",
          imagePath2: cleanTrain8,
          title2: "擦拭连接处车门边条",
        },
        {
          imagePath1: cleanTrain9,
          title1: "擦拭地面",
          imagePath2: cleanTrain10,
          title2: "擦拭窗台",
        },
        {
          imagePath1: cleanTrain11,
          title1: "仪容仪表",
          imagePath2: cleanTrain12,
          title2: "列队接车",
        },
        {
          imagePath1: cleanTrain13,
          title1: "检查作业工具",
          imagePath2: cleanTrain14,
          title2: "转向架",
        },
        {
          imagePath1: cleanTrain15,
          title1: "裙板",
          imagePath2: cleanTrain16,
          title2: "连接处胶皮",
        },
        {
          imagePath1: cleanTrain17,
          title1: "蓝线以下侧壁",
          imagePath2: cleanTrain18,
          title2: "机头",
        },
        {
          imagePath1: cleanTrain19,
          title1: "登顶",
          imagePath2: cleanTrain20,
          title2: "擦拭车身外皮",
        },
        {
          imagePath1: cleanTrain21,
          title1: "杂志定型",
          imagePath2: cleanTrain22,
          title2: "巡视车厢",
        },
        {
          imagePath1: cleanTrain23,
          title1: "投放垃圾",
          imagePath2: cleanTrain24,
          title2: "收取垃圾",
        },
        {
          imagePath1: cleanTrain25,
          title1: "清洁马桶",
          imagePath2: cleanTrain26,
          title2: "喷洒空气清新剂",
        },
        {
          imagePath1: cleanTrain27,
          title1: "工具箱定位",
          imagePath2: cleanTrain28,
          title2: "更换垃圾袋",
        },
        {
          imagePath1: cleanTrain29,
          title1: "放客立岗",
          imagePath2: cleanTrain30,
          title2: "擦拭洗手盆",
        },
        {
          imagePath1: cleanTrain31,
          title1: "擦拭端门玻璃",
          imagePath2: cleanTrain32,
          title2: "擦拭电茶炉",
        },
        {
          imagePath1: cleanTrain33,
          title1: "补充清洁袋",
          imagePath2: cleanTrain34,
          title2: "备品定位",
        },
        {
          imagePath1: cleanTrain35,
          title1: "座椅扶手槽内小桌板",
          imagePath2: cleanTrain36,
          title2: "卫生间作业标准",
        },
        {
          imagePath1: cleanTrain37,
          title1: "卫生间地面",
          imagePath2: cleanTrain38,
          title2: "清扫地面",
        },
        {
          imagePath1: cleanTrain39,
          title1: "铺放头枕片",
          imagePath2: cleanTrain40,
          title2: "垃圾箱",
        },
        {
          imagePath1: cleanTrain41,
          title1: "擦拭座椅转向支架",
          imagePath2: cleanTrain42,
          title2: "擦拭座椅腿",
        },
      ],
      houseList: [
        {
          imagePath1: cleanHouse1,
          title1: "星级服务",
          imagePath2: cleanHouse2,
          title2: "跑腿代购",
        },
        {
          imagePath1: cleanHouse3,
          title1: "家具陈列",
          imagePath2: cleanHouse4,
          title2: "内务打理",
        },
        {
          imagePath1: cleanHouse5,
          title1: "微波炉清洗",
          imagePath2: cleanHouse6,
          title2: "电器维修",
        },
        {
          imagePath1: cleanHouse7,

          title1: "空调维修",
          imagePath2: cleanHouse8,
          title2: "管道疏通",
        },
        {
          imagePath1: cleanHouse9,
          title1: "沙发保养（皮，布）",
          imagePath2: cleanHouse10,
          title2: "地板打蜡",
        },
        {
          imagePath1: cleanHouse11,
          title1: "厨房保养",
          imagePath2: cleanHouse12,
          title2: "高空清洁",
        },
        {
          imagePath1: cleanHouse13,
          title1: "地毯清洗",
          imagePath2: cleanHouse14,
          title2: "深度保洁",
        },
      ],
      show: false
    };
  },
  methods: {
    navigateToModule(route) {
      this.show = false;
      this.$router.push(route);
    },
    popupShow() {
      this.show = !this.show
    },
    goToNewsDetail(data) {
      const targetRoute = this.$router.resolve(`/news/detail${data}`);
      window.open(targetRoute.href, "_blank");
    },
    openExternalLink(url) {
      if (typeof window !== 'undefined') {
        window.open(url);
      }
    },
  },
  mounted() { },
};
</script>
<style lang="scss" scoped>
.nav {
  height: 15vw;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.nav .nav_right {
  max-width: 70vw;
  height: auto;
}

.nav .left {
  max-width: 10vw;
  height: auto;
  margin-right: 3vw;
}

.left {
  padding-top: 4vw;
  padding-bottom: 3vw;
}

.phone {
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffb400;
  width: 100%;
  height: 20vw;
  background-color: rgba(55, 55, 55, 1);
  background-size: cover;
  background-position: center;
}

.content {
  font-size: 3vw;
  margin-top: 5vw;
  margin-bottom: 5vw;

  img {
    width: 25vw;
    margin: 0 1vw;
  }

  display: flex;
  justify-content: space-around;
  align-items: center;
  color: #696969;

  .content_chara {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 30vw;
    height: 100%;
    img, h3 {
      flex-shrink: 0;
    }
    span {
      flex-grow: 1;
      height: 60px;
    }
  }
}

.main-navban {
  position: fixed;
  left: 0;
  width: 100%;
  right: 0px;
  z-index: 100;
  bottom: -1px;
  height: 15vw;
  background: rgba(101, 190, 186, 1);
  display: flex;
  justify-content: center;
  align-items: center;

  &-left {
    flex: 1;
    font-size: 12px;
    display: flex;
    height: 82px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    line-height: 1.5em;
    color: rgba(0, 0, 0, 0.3);
  }

  &-right {
    flex: 2;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
    margin-right: 2%;
    text-align: center;
    border-radius: 60px;
    color: #ffffff;
    background: linear-gradient(110deg, #1fcb43 -1%, #fffda4 129%);
  }
}

.news-list {
  padding: 4vw;

  .news-item {
    display: flex;
    margin-bottom: 4vw;

    .news-img {
      width: 30vw;
      height: 20vw;
      object-fit: cover;
      margin-right: 3vw;
    }

    .news-content {
      flex: 1;

      h5 {
        font-size: 4vw !important;
        width: 60vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: inherit;
      }

      .news-desc {
        font-size: 3.5vw;
        color: #6B6B6B;
        margin-bottom: 1vw;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .news-time {
        padding: 1.5vw 5vw;
        font-size: 3vw;
        color: #515151;
        text-align: left;
      }
    }
  }
}
</style>